// src/frontend_react/src/components/ui/Card/Card.js
import React from 'react';
import styles from './Card.module.css';

// Helper function to map spacing tokens to CSS values
const getSpacingValue = (spacingToken) => {
    if (spacingToken === undefined || spacingToken === null) return undefined;
    if (typeof spacingToken === 'number') return `calc(var(--cipher-spacing-unit, 8px) * ${spacingToken})`;
    if (typeof spacingToken === 'string' && ['xs', 'sm', 'md', 'lg', 'xl'].includes(spacingToken)) {
        return `var(--cipher-spacing-${spacingToken})`;
    }
    return spacingToken;
};

const Card = ({
  // Card-specific props
  title,
  titleIcon, 
  headerActions, 
  children,
  className = '', 
  cardClassName = '', 
  headerClassName = '',
  titleClassName = '',
  bodyClassName = '',
  elevation = 'md', 
  noPadding = false, 
  
  mt, mb, mx, my, m, ml, mr,
  p, pt, pb, pl, pr, px, py,
  width, height, maxWidth,
  flexGrow, alignSelf,
  style,
  
  ...rest
}) => {

  const combinedCardClass = [
    styles.card,
    styles[`elevation-${elevation}`],
    cardClassName,
    className,
  ].filter(Boolean).join(' ');

  // Build an inline style object from the consumed layout props
  const combinedStyle = { ...style };
  
  // Margins
  if (mt !== undefined) combinedStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) combinedStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) combinedStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) combinedStyle.marginRight = getSpacingValue(mr);
  if (mx !== undefined) {
    combinedStyle.marginLeft = getSpacingValue(mx);
    combinedStyle.marginRight = getSpacingValue(mx);
  }
  if (my !== undefined) {
    combinedStyle.marginTop = getSpacingValue(my);
    combinedStyle.marginBottom = getSpacingValue(my);
  }
  if (m !== undefined) combinedStyle.margin = getSpacingValue(m);
  
  // Padding on the body is controlled by `noPadding` prop, but you could add props for it if needed

  // Dimensions & Flex
  if (width !== undefined) combinedStyle.width = width;
  if (height !== undefined) combinedStyle.height = height;
  if (maxWidth !== undefined) combinedStyle.maxWidth = maxWidth;
  if (flexGrow !== undefined) combinedStyle.flexGrow = flexGrow;
  if (alignSelf !== undefined) combinedStyle.alignSelf = alignSelf;

  return (
    <div className={combinedCardClass} style={combinedStyle} {...rest}>
      {(title || headerActions) && (
        <div className={`${styles.cardHeader} ${headerClassName}`}>
          {title && (
            <h3 className={`${styles.cardTitle} ${titleClassName}`}>
              {titleIcon && <span className={styles.titleIconWrapper}>{titleIcon}</span>}
              {title}
            </h3>
          )}
          {headerActions && (
            <div className={styles.headerActions}>
              {headerActions}
            </div>
          )}
        </div>
      )}
      <div className={`${styles.cardBody} ${noPadding ? styles.noPadding : ''} ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default Card;